import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { LoginPageViewProps } from './loginpage.props';

const LoginPageView: React.FC<LoginPageViewProps> = ({
  formData,
  isLoading,
  handleChange,
  handleSubmit,
}) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl font-bold text-center">Најави се</CardTitle>
          <CardDescription className="text-center">
            Внесете ги вашите податоци за да продолжите
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" name="email" type="email" value={formData.email} onChange={handleChange} required className="mt-1" placeholder="vase@email.com" />
            </div>
            <div>
              <Label htmlFor="password">Лозинка</Label>
              <Input id="password" name="password" type="password" value={formData.password} onChange={handleChange} required className="mt-1" placeholder="••••••••" />
            </div>
            <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700" disabled={isLoading}>
              {isLoading ? 'Се најавувам...' : 'Најави се'}
            </Button>
          </form>
          <div className="mt-6 text-center text-sm">
            <span className="text-gray-600">Немате профил? </span>
            <Link to="/register" className="text-blue-600 hover:text-blue-700 font-medium">
              Регистрирајте се
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPageView;
